import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose';
import stylePlatform from 'assets/css/style.jsx';
// core components
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'

import { connect } from 'react-redux'
import { renderSnackbar } from 'actions/snackbar'

import api from 'api'
import validate, { constraints, isEqualTo } from 'services/formValidator'
import {withStyles} from "@material-ui/core";

const reset_constraints = {
  password: [constraints.isRequired],
  confirm_password: [{assert: isEqualTo, validWhen: true, args: ['password'], message: 'Les deux mots de passe ne sont pas valid.'}]
}

class ResetPwdForm extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      errors: {}
    };
  }

  handleSubmit(e) {
    e.preventDefault()
    const formData = {
      password: e.target.password.value,
      confirm_password: e.target.confirm_password.value,
    }
    const errors = validate(formData, reset_constraints)
    if (Object.keys(errors).length === 0) {
      api.auth.reset_password({ password: formData.password, token: this.props.token })
        .then(() => {
          this.props.history.push('/login')
          this.props.renderSnackbar({
            color: 'success',
            message: 'Votre mot de passe a bien été enregistré.'
          })
        }).catch(err => {
        this.props.renderSnackbar({
          color: 'danger',
          message:err.response.data['hydra:description']
        })
      })
    }
    this.setState({ errors })
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
    const token = this.props.token
    api.auth.forgot_pwd_token(token)
      .then(resp => null)
      .catch(err => {
        this.props.history.push('/login')
        this.props.renderSnackbar({
          color: 'danger',
          message: 'Le lien que vous essayez d\'accéder est expiré ou n\'existe pas !'
        })
      })
  }

  render() {
    const { classes } = this.props
    const { errors } = this.state

    return (
      <form onSubmit={(e) => this.handleSubmit(e)}>
        <Card
          profile
          className={
            classes.customCardClass + ' ' + classes[this.state.cardAnimaton]
          }
        >
          <CardBody profile>
            <h3 className={classes.cardTitle}>Réinitialiser mon mot de passe</h3>
            <CustomInput
              labelText='Enter nouveau mot de passe'
              error={!!errors.password}
              id='password'
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: 'password',
                name: 'password'
              }}
            />
            <CustomInput
              labelText='Confirmation'
              error={!!errors.confirm_password}
              id='confirm-password'
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: 'password',
                name: 'confirm_password'
              }}
            />
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button
                className = {classes.btnLogin}
                type='submit'>
              Enregistrer
            </Button>
          </CardFooter>
        </Card>
      </form>
    )
  }
}

ResetPwdForm.propTypes = {
  classes: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  renderSnackbar: PropTypes.func.isRequired
};

export default compose(
    connect(null, { renderSnackbar }),
    withStyles(stylePlatform))
(ResetPwdForm)



// WEBPACK FOOTER //
// ./src/views/Forms/ResetPwdForm.jsx